// import Constant from '@/const'
// import Store from '@/store/index.js'
import Const from '@/const'

export default {
  namespaced: true,
  state: {
    // アカウント設定編集画面で出力するアカウント情報
    data: {
      ID: '',
      USER_ID: '',
      STATUS: '',
      SOFU_SAKI_MEI: '',
      TANTO_MEI_SEI: '',
      TANTO_MEI: '',
      MAIL_ADDR: '',
      TEHAI_KANRYO_MAIL: '',
      NOSYA_KANRYO_MAIL: '',
      FROM_PAGE: '',
    },
  },
  mutations: {
    create(state, data) {
      state.data = data
    },
    destroy(state, data) {
      state.data = null
    },
  },

  actions: {
    /** 最新バージョン確認 */
    checkVersion({ dispatch }) {
      const request = {
        url: Const.API_URL.VERSION,
      }
      return dispatch('http/get', { ...request }, { root: true }).then(
        (res) => {
          if (process.env.RELEASE_VERSION !== res.data.version) {
            location.reload(true)
          }
        }
      )
    },
  },
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js